export const LIVE_PLAYER_SITES_POLL_INTERVAL = 120_000; // 2 minutes
export const LIVE_PLAYER_CHANNELS_POLL_INTERVAL = 60_000; // 1 minute
export const FORTY_EIGHT_HOURS = 172_800; // 48 hours

export const HALF_HOUR = 1_800; // 30 minutes
export const ONE_HOUR = 3_600; // 1 hour

export const LIVE_VIDEO_STATUS = {
  ENDED: 'ended',
  NEVER_STARTED: 'never-started',
  STARTED: 'started',
} as const;
